import React, { useEffect, useState } from 'react';
import { Grid, Dialog, Typography } from '@mui/material';
import CollectionItem from './CollectionItem';






export default function TimerDialog({ dialog, setDialog, addToCart, loading }) {
  const { step, code } = dialog;
  const [timer, setTimer] = useState();
  const [product, setProduct] = useState();


  useEffect(() => {
    if (step?.type === 'timer') {
      fetch(`/products/${step.product}.json`)
        .then(r => r.json())
        .then(r => setProduct(r.product))
        .catch(console.error)
    }
  }, [step])



  useEffect(() => {
    if (code?.timer) {
      setTimer(code.timer - Date.now());
      const interval = setInterval(() => {
        setTimer(Math.max(code.timer - Date.now(), 0));
      }, 1000)
      return () => clearInterval(interval);
    } else {
      setTimer(0);
    }
  }, [code])







  return (
    <Dialog disablePortal open={step?.type === 'timer'} onClose={() => setDialog(false)} sx={{ height: '100%', bgcolor: 'grey' }} PaperProps={{ sx: { height: '100%', bgcolor: 'grey' } }}>
      <Grid container direction='column' sx={{ height: '100%' }} wrap='nowrap'>
        <Grid item sx={{ backgroundColor: "#2bbdff", p: 2, }}>
          <Typography color='white' textAlign='center'>
            {step?.message}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant='h3' textAlign='center'>{toTime(timer)}</Typography>
        </Grid>
        <Grid item>
          {product && <CollectionItem {...{ product, addToCart: (v) => addToCart(v, code, { timerExpires: code.timer }), loading, buttonText: step?.buttonText }} />}
        </Grid>
      </Grid>
    </Dialog>
  )
}



function toTime(timer) {
  const min = Math.floor(timer / 60 / 1000);
  const sec = Math.round(timer / 1000 % 60) - 1;
  return timer ? `${min}:${(sec < 10 ? "0" : "") + sec}` : "00:00";
}